import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import setRules from '@/libs/rules';
import express from '@/const/express';
import { citys } from '@/const/citys';
import pintComp from '@/components/pint-comp/printComp.vue';
var expressList = express.map(function (v) {
  return {
    label: v.company,
    value: v.code
  };
});
var rule = [{
  key: 'consigneeName',
  name: '客户姓名'
}, {
  key: 'consigneeDetails',
  name: '详细地址'
}, {
  key: 'consigneePhone',
  name: '手机号',
  validator: 'validatePhone'
}];
export default {
  components: {
    pintComp: pintComp
  },
  meta: {
    title: '发出新货',
    auth: true,
    authorityValue: 'store-refund-audit'
  },
  name: 'sendNewGoods',
  data: function data() {
    return {
      expressList: expressList,
      tableData: [],
      formData: {},
      rules: {
        newExpressNumber: [{
          required: true,
          message: ' 请输入快递单号',
          trigger: 'blur'
        }],
        newExpressCompany: [{
          required: true,
          message: ' 请选择物流公司',
          trigger: 'blur'
        }]
      },
      detail: {},
      record: [],
      layer: {
        show: false,
        title: '',
        showButton: true,
        form: {},
        rules: setRules(rule)
      },
      layer2: {
        show: false,
        title: '修改出库地址',
        showButton: true,
        deliveryAddressId: '',
        options: []
      },
      active: {}
    };
  },
  filters: {
    deliveryAddress: function deliveryAddress(e) {
      var str = '';

      try {
        str = ['contactName', 'phoneNumber', 'province', 'city', 'district', 'details'].map(function (v) {
          return e[v];
        }).join(' ');
      } catch (e) {}

      return str;
    }
  },
  methods: {
    getAddressList: function getAddressList() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_this$$api$add, records;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.layer2.show = true;
                _context.next = 3;
                return _this.$api.addressList({
                  addressType: 2,
                  pageSize: 999
                });

              case 3:
                _yield$_this$$api$add = _context.sent;
                records = _yield$_this$$api$add.records;

                _this.$set(_this.layer2, 'options', records);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clickOpenStay: function clickOpenStay() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var item;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log('1111111', _this2.detail);
                _context2.next = 3;
                return _this2.$api.updateDeliveryAddressSale(_objectSpread({}, _this2.detail));

              case 3:
                YL.message('修改成功');
                _this2.layer2.show = false;

                _this2.dataBind(_this2.$route.query);

                return _context2.abrupt("return");

              case 9:
                item = _this2.layer2.options.find(function (v) {
                  return v.addressId == _this2.detail.deliveryAddressId;
                });

                _this2.$set(_this2.detail, 'deliveryAddress', _objectSpread({}, item));

                _this2.layer2.show = false;

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handleNav: function handleNav(NAME, row) {
      this.$router.push({
        name: NAME,
        query: row ? row : ''
      });
    },
    cityChange: function cityChange(e) {
      e[0] && this.$set(this.layer.form, 'consigneeProvince', e[0]);
      e[1] && this.$set(this.layer.form, 'consigneeCity', e[1]);
      e[2] && this.$set(this.layer.form, 'consigneeDistrict', e[2]);
      this.$refs.layerForm.validateField('consigneeProvince');
    },
    clickLayer: function clickLayer(item, row) {
      this.active = _objectSpread(_objectSpread({}, item), row);
      this.layer.form = _objectSpread({}, row);
      this.layer.show = true;
      this.layer.title = item.title;
    },
    dataBind: function dataBind(item) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var orderDetails;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.$api.refundDetails(_objectSpread({}, item));

              case 2:
                orderDetails = _context3.sent;
                _this3.detail = orderDetails;
                _this3.record = orderDetails;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    confirm: function confirm() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this4.active.type == 'updateConsignee2')) {
                  _context5.next = 4;
                  break;
                }

                _this4.$refs.layerForm.validate( /*#__PURE__*/function () {
                  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(valid) {
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            if (!valid) {
                              _context4.next = 7;
                              break;
                            }

                            citys.forEach(function (e) {
                              if (_this4.layer.form.consigneeProvince == e.label.split('市')[0] || e.label.split('省')[0] || e.label.split('壮族自治区')[0]) {
                                _this4.$set(_this4.layer.form, 'provinceCode', e.value);

                                e.children.forEach(function (_e) {
                                  if (_this4.layer.form.consigneeCity == _e.label) {
                                    _this4.$set(_this4.layer.form, 'cityCode', _e.value);

                                    _e.children.forEach(function (__e) {
                                      if (_this4.layer.form.consigneeDistrict == __e.label) {
                                        _this4.$set(_this4.layer.form, 'districtCode', __e.value);
                                      }
                                    });
                                  }
                                });
                              }
                            });
                            _context4.next = 4;
                            return _this4.$api[_this4.active.type]({
                              consigneeInfo: _objectSpread({}, _this4.layer.form),
                              refundId: _this4.active.refundId
                            });

                          case 4:
                            _this4.$notify.success({
                              title: '成功',
                              message: '修改成功'
                            });

                            _this4.dataBind(_this4.$route.query);

                            _this4.layer.show = false;

                          case 7:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

                _context5.next = 9;
                break;

              case 4:
                _context5.next = 6;
                return _this4.$api[_this4.active.type](_objectSpread(_objectSpread({}, _this4.layer.form), {}, {
                  orderId: _this4.active.orderId
                }));

              case 6:
                _this4.$notify.success({
                  title: '成功',
                  message: '修改成功'
                });

                _this4.dataBind(_this4.$route.query);

                _this4.layer.show = false;

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    submin: function submin() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this5.$refs.formData.validate( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(valid) {
                    return regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            if (!valid) {
                              _context6.next = 5;
                              break;
                            }

                            _context6.next = 3;
                            return _this5.$api.refund_delivery(_objectSpread(_objectSpread({
                              deliveryAddressId: _this5.detail.deliveryAddressId
                            }, _this5.formData), _this5.$route.query));

                          case 3:
                            _this5.$notify.success({
                              title: '成功',
                              message: '出库成功'
                            });

                            _this5.goBack();

                          case 5:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    copyThat: function copyThat() {
      YL.copyThat(this.detail.orderNo);
    }
  },
  created: function created() {
    this.dataBind(this.$route.query);
  }
};